// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2iU6B","bigColWidth":"Table_bigColWidth__OxBRf","biggerColWidth":"Table_biggerColWidth__3lX9T","row":"Table_row__ePT8d","col":"Table_col__1p_f1"};